<template>
  <div class="ma-4 px-4">
    <searchBar
      v-if="!viewPartner"
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="partners"
            fixed-header
            class="secondary row-height-50"
            :items-per-page="viewPartner ? itemsPerPage : 10"
            :hide-default-footer="viewPartner"
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                :disabled="!item.active"
                small
                class="mr-2"
                color="accent"
                @click="edit(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.partner_approval_required`]="{ value }">
              {{ value ? "Yes" : "No" }}
            </template>
            <template #[`item.partner_payment_required`]="{ value }">
              {{ value ? "Yes" : "No" }}
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item.active) }}
              </v-chip>
            </template>
            <template #[`item.name`]="{ item }">
              <span
                :class="{
                  'accent--text': !viewPartner,
                }"
                :style="{
                  textDecoration: !viewPartner ? 'underline' : 'none',
                  cursor: !viewPartner ? 'pointer' : 'auto',
                }"
                @click="!viewPartner ? goToPartnerView(item.id) : ''"
              >
                {{ item.name }}
              </span>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createPartner"
        @update="updatePartner"
        :partner="partner"
        :partners="partners"
        :programs="programs"
        :edit="editMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="partner"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/partner/form.vue";
import searchBar from "@/components/searchBar.vue";
import { partnerHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";

export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  props: {
    partners: {
      type: Array,
      default: () => [],
    },
    viewPartner: {
      type: Boolean,
      default: () => false,
    },
    programs: {
      type: Array,
      default: () => [],
    },
    itemsPerPage: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      partner: {},
      search: "",
      headers: partnerHeaders,
      showDialog: false,
      currentItem: {},
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    goToPartnerView(id) {
      this.$router.push({ name: "View Partner", params: { id } });
    },
    initialise() {
      this.$emit("getPartners");
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    async createPartner(data) {
      await this.$axios
        .post("partners", { partner: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Partner created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updatePartner(data) {
      await this.$axios
        .put("partners/" + data.id, { partner: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Partner updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updatePartner({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },

    edit(item) {
      const partner_item = {
        ...item,
        adm_approval_reqd: item.partner_approval_required,
        adm_applicant_fee_collect: item.partner_payment_required,
      };
      this.partner = { ...partner_item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.currentItem = {};
      this.partner = {};
    },
  },
};
</script>

<style></style>
